// import styles from "./StateSelector.module.css";

// const StateSelector = ({
//     hotels = [],
//     selectedState,
//     onStateChange,
// }) => {

//   const states = [
//     ...new Set(
//         hotels
//             .map((hotel) => hotel.state?.trim())
//             .filter(Boolean)
//     ),
// ].sort((a, b) =>
//     a.localeCompare(b, undefined, {
//         sensitivity: "base",
//     })
// );

//     return (
//         <div className={styles.container}>
//             <label className={styles.label}>
//                Find Your Venue
//             </label>

//             <select
//                 className={styles.select}
//                 value={selectedState}
//                 onChange={(e) => onStateChange(e.target.value)}
//             >
//                 <option value="">
//                     Select State
//                 </option>

//                 {states.map((state) => (
//                     <option
//                         key={state}
//                         value={state}
//                     >
//                         {state}
//                     </option>
//                 ))}
//             </select>
//         </div>
//     );
// };

// export default StateSelector;


import styles from "./StateSelector.module.css";

const StateSelector = ({
  hotels = [],
  selectedState,
  onStateChange,
}) => {
  const states = [
    ...new Set(
      hotels
        .map((hotel) => hotel.state?.trim())
        .filter(Boolean)
    ),
  ].sort((a, b) =>
    a.localeCompare(b, undefined, {
      sensitivity: "base",
    })
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <label
          className={styles.label}
          htmlFor="venue-state-select"
        >
          Find Your Venue
        </label>

        {selectedState && (
          <button
            type="button"
            className={styles.clearButton}
            onClick={() => onStateChange("")}
            aria-label="Clear selected state and city"
          >
            <span aria-hidden="true">×</span>
            Clear Selection
          </button>
        )}
      </div>

      <select
        id="venue-state-select"
        className={styles.select}
        value={selectedState}
        onChange={(e) => onStateChange(e.target.value)}
      >
        <option value="">Select State</option>

        {states.map((state) => (
          <option key={state} value={state}>
            {state}
          </option>
        ))}
      </select>
    </div>
  );
};

export default StateSelector;
